// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-partition-module--sm{margin-top:24px}@media (min-width:768px){.v-partition-module--sm{margin-top:32px}}.v-partition-module--md{margin-top:48px}@media (min-width:768px){.v-partition-module--md{margin-top:64px}}.v-partition-module--lg{margin-top:96px}@media (min-width:768px){.v-partition-module--lg{margin-top:128px}}", ""]);
// Exports
module.exports = exports;
